import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { participationFeesActions } from '../../../application/actions/participationFees';

import api from '../../api';

const apiGeneralParams = api(process.env.REACT_APP_PARTICIPATION_FEE_API);

export function* fetchParticipationFees(action) {
  try {
    const { data } = yield call(apiGeneralParams.get, 'v1/consultar', action.payload);
    /* istanbul ignore next */
    if (data) yield put(participationFeesActions.fetchParticipationFeesSuccess(data));
    else yield put(participationFeesActions.fetcchParticipationFeesError());
  } catch (err) {
    console.error('participation feeds saga error:', err);
    yield put(participationFeesActions.fetcchParticipationFeesError());
  }
}

export function* watchFetchParticipationFees() {
  yield takeLatest(participationFeesActions.fetchParticipationFees.type, fetchParticipationFees);
}
/* istanbul ignore next */
export default function* participationFeesSaga() {
  yield spawn(watchFetchParticipationFees);
}
